import type { UserProfile } from '@/types';
import { api } from '@/api/client';

// PostHog has been removed. The exported functions are kept so callers don't break;
// they now only mirror events to our own backend funnel store (which is the source
// of truth for the Analytics dashboard).

export function initAnalytics(): void {
  // no-op
}

export function identifyUser(_user: UserProfile): void {
  // no-op
}

export function resetUser(): void {
  // no-op
}

export function capturePageview(_pathname: string): void {
  // no-op — backend tracks page views via /api/track/* middleware
}

/**
 * Track a custom event. Fire-and-forget — failures are swallowed so a network
 * blip never breaks the user's flow.
 */
export function track(name: string, props?: Record<string, unknown>): void {
  api.post('/api/track/event', { name, ...(props ? { props } : {}) }).catch(() => {});
}
